/**
 * Curated unDraw scenes (https://undraw.co/illustrations/) via the `undraw-svg` package (MIT).
 * SVG accents use `currentColor` — set `text-primary` on the wrapper to match the app theme.
 */
import accessDeniedSvg from 'undraw-svg/access-denied.svg?raw';
import bugFixingSvg from 'undraw-svg/bug-fixing.svg?raw';
import mailSentSvg from 'undraw-svg/mail-sent.svg?raw';
import secureLoginSvg from 'undraw-svg/secure-login.svg?raw';
import signUpSvg from 'undraw-svg/sign-up.svg?raw';
import voidSvg from 'undraw-svg/void.svg?raw';

export const UNDRAW_SCENES = {
  'secure-login': secureLoginSvg,
  'sign-up': signUpSvg,
  'mail-sent': mailSentSvg,
  'access-denied': accessDeniedSvg,
  'bug-fixing': bugFixingSvg,
  void: voidSvg,
} as const;

export type UndrawScene = keyof typeof UNDRAW_SCENES;

export function getUndrawSvg(scene: UndrawScene): string {
  return UNDRAW_SCENES[scene];
}
